export const formatCurrency = (value: string) => {
  return value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const changeToToman = (value: string) => {
  return String(Number(value) / 10);
};

export const reverseFormatCurrency = (value: string) => {
  const raw = value.replace(/,/g, "");
  return raw;
};

export const numberToPersianWords = (num: string) => {
  const units = [
    "صفر",
    "یک",
    "دو",
    "سه",
    "چهار",
    "پنج",
    "شش",
    "هفت",
    "هشت",
    "نه",
  ];
  const teens = [
    "ده",
    "یازده",
    "دوازده",
    "سیزده",
    "چهارده",
    "پانزده",
    "شانزده",
    "هفده",
    "هجده",
    "نوزده",
  ];
  const tens = [
    "",
    "",
    "بیست",
    "سی",
    "چهل",
    "پنجاه",
    "شصت",
    "هفتاد",
    "هشتاد",
    "نود",
  ];
  const hundreds = [
    "صد",
    "دویست",
    "سیصد",
    "چهارصد",
    "پانصد",
    "ششصد",
    "هفتصد",
    "هشتصد",
    "نهصد",
  ];

  const convert = (n: number): string => {
    if (n < 10) return units[n];
    if (n < 20) return teens[n - 10];
    if (n < 100)
      return (
        tens[Math.floor(n / 10)] + (n % 10 !== 0 ? " و " + units[n % 10] : "")
      );
    if (n < 1000)
      return (
        hundreds[Math.floor(n / 100) - 1] +
        (n % 100 !== 0 ? " و " + convert(n % 100) : "")
      );
    if (n < 1000000)
      return (
        convert(Math.floor(n / 1000)) +
        " هزار" +
        (n % 1000 !== 0 ? " و " + convert(n % 1000) : "")
      );
    if (n < 1000000000)
      return (
        convert(Math.floor(n / 1000000)) +
        " میلیون" +
        (n % 1000000 !== 0 ? " و " + convert(n % 1000000) : "")
      );
    return (
      convert(Math.floor(n / 1000000000)) +
      " میلیارد" +
      (n % 1000000000 !== 0 ? " و " + convert(n % 1000000000) : "")
    );
  };

  return num === "" ? "" : convert(Number(num) / 10) + " تومان";
};
